import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import styles from '../styles.pcss';
const cx = classNames.bind(styles);

export const ServiceDownloadUrlList = ({ downloadUrls, children }) => (
  <div className={cx('download-url-list')}>
    {downloadUrls?.map(children)}
  </div>
);

ServiceDownloadUrlList.propTypes = {
  downloadUrls: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      url: PropTypes.string,
      language: PropTypes.string,
      platform: PropTypes.string,
    }),
  ),
  children: PropTypes.func,
};
